import React from 'react';
import { Container, Row } from 'reactstrap';
import { DashboardPageHeader } from '../../../Components/Common/DashboardKit';
import Widgets from './Widgets';
import TicketsData from './TicketsData';


const ListView = () => {
    document.title="Tickets List | Velzon - React Admin & Dashboard Template";
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>                    
                    <DashboardPageHeader
                        icon="ri-customer-service-2-line"
                        title="Tickets List"
                        subtitle="Open issues, queues, and resolution status"
                        tone="rose"
                        breadcrumb={[
                            { label: "Tickets" },
                            { label: "Tickets List" },
                        ]}
                    />
                    <Row>
                        <Widgets />
                    </Row>
                    <TicketsData />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default ListView;